import * as Types from '../../graphql/types'

import { gql } from 'apollo-boost'
import * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from '@apollo/react-hooks'
const defaultOptions = {}
export type AddScheduledActionMutationVariables = Types.Exact<{
  input: Types.AddScheduledActionInput
}>

export type AddScheduledActionMutation = { __typename?: 'Mutation'; addScheduledAction: boolean }

export const AddScheduledActionDocument = gql`
  mutation AddScheduledAction($input: AddScheduledActionInput!) {
    addScheduledAction(input: $input)
  }
`
export type AddScheduledActionMutationFn = ApolloReactCommon.MutationFunction<
  AddScheduledActionMutation,
  AddScheduledActionMutationVariables
>
export function useAddScheduledActionMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AddScheduledActionMutation,
    AddScheduledActionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    AddScheduledActionMutation,
    AddScheduledActionMutationVariables
  >(AddScheduledActionDocument, options)
}
export type AddScheduledActionMutationHookResult = ReturnType<typeof useAddScheduledActionMutation>
export type AddScheduledActionMutationResult =
  ApolloReactCommon.MutationResult<AddScheduledActionMutation>
export type AddScheduledActionMutationOptions = ApolloReactCommon.BaseMutationOptions<
  AddScheduledActionMutation,
  AddScheduledActionMutationVariables
>
